
document.addEventListener("DOMContentLoaded", function() {
  // Only run on collection pages
  if (
    document.querySelector(".collection-grid") ||
    document.querySelector(".collection-products") ||
    document.querySelector(".collection")
  ) {
    let touchStartX = 0;
    let touchEndX = 0;
    let swipeStartTime = 0;
    let swipeEndTime = 0;
    let lastSwipeTime = 0;
    let swipeCount = 0;
    let swipeDirection = "";

    // Get pagination links - focus only on chronological next/prev links
    const nextPageLink = document.querySelector(
      'a.pagination__next, a[rel="next"], a.next-page'
    );
    const prevPageLink = document.querySelector(
      'a.pagination__prev, a[rel="prev"], a.prev-page'
    );

    // Try to get additional page links for multi-page jumps
    const allPageLinks = document.querySelectorAll(
      ".pagination a, .pagination__item a"
    );
    let pageLinks = [];
    let currentPageIndex = -1;

    // Determine current page and build ordered list of page links
    if (allPageLinks.length > 0) {
      allPageLinks.forEach((link, index) => {
        if (
          !link.getAttribute("href")?.includes("#") &&
          !link.classList.contains("pagination__next") &&
          !link.classList.contains("pagination__prev")
        ) {
          pageLinks.push(link);

          // Check if this is the current page
          if (
            link.getAttribute("aria-current") === "page" ||
            link.classList.contains("current") ||
            link.classList.contains("pagination--current")
          ) {
            currentPageIndex = pageLinks.length - 1;
          }
        }
      });
    }

    // Add touch event listeners to the collection container
    const collectionContainer = document.querySelector(
      ".collection-grid, .collection-products, .collection, main"
    );

    if (collectionContainer) {
      collectionContainer.addEventListener(
        "touchstart",
        function(event) {
          touchStartX = event.changedTouches[0].screenX;
          swipeStartTime = new Date().getTime();

          // Reset swipe count if it's been more than 800ms since the last swipe
          const now = new Date().getTime();
          if (now - lastSwipeTime > 800) {
            swipeCount = 0;
            swipeDirection = "";
          }
        },
        false
      );

      collectionContainer.addEventListener(
        "touchend",
        function(event) {
          touchEndX = event.changedTouches[0].screenX;
          swipeEndTime = new Date().getTime();
          handleSwipe();
        },
        false
      );
    }

    // Handle the swipe gesture
    function handleSwipe() {
      const swipeThreshold = 80; // Minimum distance to be considered a swipe
      const swipeDistance = touchEndX - touchStartX;
      const swipeTime = swipeEndTime - swipeStartTime;

      // Only count quick swipes (less than 300ms)
      if (swipeTime > 300) {
        return;
      }

      if (Math.abs(swipeDistance) > swipeThreshold) {
        // Determine swipe direction
        const direction = swipeDistance < 0 ? "left" : "right";

        // If this is a new swipe sequence or same direction as before, count it
        if (swipeDirection === "" || swipeDirection === direction) {
          swipeDirection = direction;
          swipeCount++;
          lastSwipeTime = swipeEndTime;

          // Show visual feedback immediately
          showFeedback(direction, swipeCount);

          // Wait a bit to see if multiple swipes are performed
          setTimeout(() => {
            const now = new Date().getTime();
            // If no new swipes in 500ms, process the navigation
            if (now - lastSwipeTime >= 500) {
              navigateToPage(direction, swipeCount);
              swipeCount = 0;
              swipeDirection = "";
            }
          }, 500);
        } else {
          // Direction changed, reset counter
          swipeDirection = direction;
          swipeCount = 1;
          lastSwipeTime = swipeEndTime;
          showFeedback(direction, swipeCount);
        }
      }
    }

    // Navigate to the appropriate page based on swipe direction and count
    function navigateToPage(direction, count) {
      if (direction === "left") {
        // Next page(s) - chronological forward
        if (pageLinks.length > 0 && currentPageIndex !== -1) {
          // Try to jump multiple pages
          const targetIndex = Math.min(
            currentPageIndex + count,
            pageLinks.length - 1
          );
          if (targetIndex > currentPageIndex) {
            window.location.href = pageLinks[targetIndex].href;
            return;
          }
        }

        // Fallback to simple next page
        if (nextPageLink) {
          window.location.href = nextPageLink.href;
        }
      } else if (direction === "right") {
        // Previous page(s) - chronological backward
        if (pageLinks.length > 0 && currentPageIndex !== -1) {
          // Try to jump multiple pages
          const targetIndex = Math.max(currentPageIndex - count, 0);
          if (targetIndex < currentPageIndex) {
            window.location.href = pageLinks[targetIndex].href;
            return;
          }
        }

        // Fallback to simple previous page
        if (prevPageLink) {
          window.location.href = prevPageLink.href;
        }
      }
    }

    // Create feedback element
    let feedback = document.createElement("div");
    feedback.style.cssText =
      "position: fixed; top: 50%; transform: translateY(-50%); padding: 15px; background: rgba(0,0,0,0.7); color: white; border-radius: 5px; opacity: 0; transition: opacity 0.3s; z-index: 9999; pointer-events: none; text-align: center;";
    document.body.appendChild(feedback);

    let feedbackTimeout;

    // Show visual feedback for swipes
    function showFeedback(direction, count) {
      clearTimeout(feedbackTimeout);

      let message = "";
      let pageJump = count > 1 ? ` (${count} pages)` : "";

      if (direction === "right") {
        message = `← Previous Page${pageJump}`;
        feedback.style.left = "20px";
        feedback.style.right = "auto";
      } else {
        message = `Next Page →${pageJump}`;
        feedback.style.right = "20px";
        feedback.style.left = "auto";
      }

      feedback.textContent = message;
      feedback.style.opacity = "1";

      // Automatically hide the feedback after a delay
      feedbackTimeout = setTimeout(() => {
        feedback.style.opacity = "0";
      }, 1500);
    }

    // Add visual feedback during swipe
    if (collectionContainer) {
      let touchMoveX = 0;

      collectionContainer.addEventListener(
        "touchmove",
        function(event) {
          touchMoveX = event.changedTouches[0].screenX;
          const swipeDiff = touchMoveX - touchStartX;

          if (Math.abs(swipeDiff) > 50) {
            const now = new Date().getTime();
            const timeSinceStart = now - swipeStartTime;

            if (timeSinceStart < 300) {
              // Only show during quick swipes
              if (swipeDiff > 0 && prevPageLink) {
                feedback.textContent = "← Previous Page";
                feedback.style.left = "20px";
                feedback.style.right = "auto";
                feedback.style.opacity = "1";
              } else if (swipeDiff < 0 && nextPageLink) {
                feedback.textContent = "Next Page →";
                feedback.style.right = "20px";
                feedback.style.left = "auto";
                feedback.style.opacity = "1";
              }
            }
          }
        },
        false
      );
    }
  }
});